export default __webpack_public_path__ + "maps-overview-symbol-layer-960-c2a21b12d29416730eeece4d69d8a9ee.webp";